export const stats = [
  {
    Season: '1930-31',
    Club: 'Minneapolis Americans',
    League: 'NWHL',
    'REGULAR SEASON': {
      GP: null,
      G: null,
      A: null,
      TP: null,
      PIM: null,
      '+/-': null
    },
    PLAYOFFS: {
      GP: null,
      G: null,
      A: null,
      TP: null,
      PIM: null
    }
  }, {
    Season: '1931-32',
    Club: 'Minneapolis Millers',
    League: 'CHL',
    'REGULAR SEASON': {
      GP: 34,
      G: 9,
      A: 4,
      TP: 13,
      PIM: 24,
      '+/-': null
    },
    PLAYOFFS: {
      GP: null,
      G: null,
      A: null,
      TP: null,
      PIM: null
    }
  }, {
    Season: '1932-33',
    Club: 'Minneapolis Millers',
    League: 'CHL',
    'REGULAR SEASON': {
      GP: 39,
      G: 6,
      A: 8,
      TP: 14,
      PIM: 30,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 7,
      G: 0,
      A: 1,
      TP: 1,
      PIM: 11
    }
  }, {
    Season: '1933-34',
    Club: 'Minneapolis Millers',
    League: 'CHL',
    'REGULAR SEASON': {
      GP: 36,
      G: 9,
      A: 13,
      TP: 22,
      PIM: 21,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 3,
      G: 0,
      A: 2,
      TP: 2,
      PIM: 2
    }
  }, {
    Season: '1934-35',
    Club: 'St. Paul Saints',
    League: 'CHL',
    'REGULAR SEASON': {
      GP: 45,
      G: 6,
      A: 13,
      TP: 19,
      PIM: 38,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 8,
      G: 2,
      A: 5,
      TP: 7,
      PIM: 8
    }
  }, {
    Season: '1935-36',
    Club: 'St. Paul Saints',
    League: 'AHA',
    'REGULAR SEASON': {
      GP: 47,
      G: 9,
      A: 20,
      TP: 29,
      PIM: 14,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 5,
      G: 0,
      A: 1,
      TP: 1,
      PIM: 4
    }
  }, {
    Season: '1936-37',
    Club: 'St. Paul Saints',
    League: 'AHA',
    'REGULAR SEASON': {
      GP: 48,
      G: 4,
      A: 15,
      TP: 19,
      PIM: 35,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 3,
      G: 0,
      A: 2,
      TP: 2,
      PIM: 4
    }
  }, {
    Season: '1937-38',
    Club: 'Chicago Black Hawks',
    League: 'NHL',
    'REGULAR SEASON': {
      GP: 25,
      G: 0,
      A: 2,
      TP: 2,
      PIM: 2,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 10,
      G: 0,
      A: 0,
      TP: 0,
      PIM: 0
    }
  }, {
    Season: '1937-38',
    Club: '	St. Paul Saints',
    League: 'AHA',
    'REGULAR SEASON': {
      GP: 24,
      G: 2,
      A: 6,
      TP: 8,
      PIM: 14,
      '+/-': null
    },
    PLAYOFFS: {
      GP: null,
      G: null,
      A: null,
      TP: null,
      PIM: null
    }
  }, {
    Season: '1938-39',
    Club: '	St. Paul Saints',
    League: 'AHA',
    'REGULAR SEASON': {
      GP: 48,
      G: 5,
      A: 12,
      TP: 17,
      PIM: 22,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 3,
      G: 1,
      A: 0,
      TP: 1,
      PIM: 0
    }
  }, {
    Season: '1939-40',
    Club: '	St. Paul Saints',
    League: 'AHA',
    'REGULAR SEASON': {
      GP: 45,
      G: 6,
      A: 16,
      TP: 22,
      PIM: 15,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 7,
      G: 0,
      A: 1,
      TP: 1,
      PIM: 6
    }
  }, {
    Season: '1940-41',
    Club: '	St. Paul Saints',
    League: 'AHA',
    'REGULAR SEASON': {
      GP: 48,
      G: 6,
      A: 15,
      TP: 21,
      PIM: 14,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 4,
      G: 0,
      A: 0,
      TP: 0,
      PIM: 4
    }
  }, {
    Season: '1941-42',
    Club: '	St. Paul Saints',
    League: 'AHA',
    'REGULAR SEASON': {
      GP: 49,
      G: 8,
      A: 17,
      TP: 25,
      PIM: 18,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 2,
      G: 1,
      A: 0,
      TP: 1,
      PIM: 0
    }
  }, {
    Season: '1942-43',
    Club: '	Hershey Bears',
    League: 'AHL',
    'REGULAR SEASON': {
      GP: 53,
      G: 4,
      A: 19,
      TP: 23,
      PIM: 10,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 6,
      G: 0,
      A: 4,
      TP: 4,
      PIM: 0
    }
  }, {
    Season: '1943-44',
    Club: '	Chicago Black Hawks',
    League: 'NHL',
    'REGULAR SEASON': {
      GP: 48,
      G: 1,
      A: 8,
      TP: 9,
      PIM: 23,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 9,
      G: 0,
      A: 3,
      TP: 3,
      PIM: 4
    }
  }, {
    Season: '1944-45',
    Club: '	Chicago Black Hawks',
    League: 'NHL',
    'REGULAR SEASON': {
      GP: 2,
      G: 0,
      A: 1,
      TP: 1,
      PIM: 2,
      '+/-': null
    },
    PLAYOFFS: {
      GP: null,
      G: null,
      A: null,
      TP: null,
      PIM: null
    }
  }, {
    Season: '1944-45',
    Club: 'Cleveland Barons',
    League: 'AHL',
    'REGULAR SEASON': {
      GP: 26,
      G: 2,
      A: 5,
      TP: 7,
      PIM: 10,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 8,
      G: 0,
      A: 0,
      TP: 0,
      PIM: 2
    }
  }, {
    Season: '1945-46',
    Club: 'Minneapolis Millers',
    League: 'USHL',
    'REGULAR SEASON': {
      GP: 53,
      G: 9,
      A: 17,
      TP: 26,
      PIM: 12,
      '+/-': null
    },
    PLAYOFFS: {
      GP: null,
      G: null,
      A: null,
      TP: null,
      PIM: null
    }
  }, {
    Season: '1946-47',
    Club: 'Minneapolis Millers',
    League: 'USHL',
    'REGULAR SEASON': {
      GP: 51,
      G: 2,
      A: 19,
      TP: 21,
      PIM: 30,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 3,
      G: 0,
      A: 0,
      TP: 0,
      PIM: 2
    }
  }, {
    Season: '1948-49',
    Club: '	Minneapolis Jerseys',
    League: 'AAHL',
    'REGULAR SEASON': {
      GP: 8,
      G: 1,
      A: 5,
      TP: 6,
      PIM: 0,
      '+/-': null
    },
    PLAYOFFS: {
      GP: null,
      G: null,
      A: null,
      TP: null,
      PIM: null
    }
  }, {
    Season: '1950-51',
    Club: '	Minneapolis Jerseys',
    League: 'AAHL',
    'REGULAR SEASON': {
      GP: 18,
      G: 2,
      A: 19,
      TP: 21,
      PIM: 2,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 3,
      G: 0,
      A: 2,
      TP: 2,
      PIM: 0
    }
  }, {
    Season: '1951-52',
    Club: 'St. Paul Saints',
    League: 'AAHL',
    'REGULAR SEASON': {
      GP: 34,
      G: 10,
      A: 19,
      TP: 29,
      PIM: 12,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 3,
      G: 0,
      A: 5,
      TP: 5,
      PIM: 0
    }
  }, {
    Season: 'NHL Totals',
    Club: '',
    League: '',
    'REGULAR SEASON': {
      GP: 75,
      G: 1,
      A: 11,
      TP: 12,
      PIM: 27,
      '+/-': null
    },
    PLAYOFFS: {
      GP: 19,
      G: 0,
      A: 3,
      TP: 3,
      PIM: 4
    }
  }
];
